import React from 'react'

const MandatoryTermsAgreement = ({file}) => {
  return (
    <div style={{
      margin: 0,        // Remove any margin
      padding: 0,       // Remove any padding
      height: '100vh',   // Make the div take full height of the viewport
      width: '100vw',    // Make the div take full width of the viewport
      overflow: 'hidden' // Prevent scrolling
    }}>
      <iframe
        src={file}
        title="Code of Ethics"
        style={{
          width: '100%',   // 100% width of the parent
          height: '100%',  // 100% height of the parent
          border: 'none',  // Optional: Removes iframe border
        }}
      />
    </div>
  )
}

export default MandatoryTermsAgreement
